/**
 * Candela — Add to Cart button price sync
 *
 * Dawn's toggleSubmitButton() overwrites the button text with just "Add to cart"
 * on variant change. This script re-injects the variant price after Dawn's update.
 */
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const { sectionId, html, variant } = data;
    if (!variant || !variant.available) return;

    requestAnimationFrame(() => {
      const section = document.getElementById(`MainProduct-${sectionId}`)
        || document.querySelector(`[id^="MainProduct"]`);
      if (!section) return;

      const btnSpan = section.querySelector('.product-form__submit span');
      if (!btnSpan) return;

      const priceEl = html.querySelector(`#price-${sectionId} .price-item--regular`)
        || html.querySelector(`#price-${sectionId} .price-item--sale`)
        || html.querySelector(`#price-${sectionId} .price-item`);

      if (priceEl) {
        const price = priceEl.textContent.trim();
        const addText = window.variantStrings?.addToCart || 'Add to cart';
        btnSpan.textContent = `${addText} ${price}`;
      }
    });
  });
});
